module.exports = __webpack_public_path__ + "img/bootstrap.9e70bc60.svg";